import { Table, Button, Modal, Select } from 'antd';
import "./cron.css"
import { useEffect, useState } from 'react';
import { backendUrl } from '../../Config';
import { ajaxFetchCall } from '../../services/ApiService';
import { appendKey, convertToGraphQl, createGraphQlFilters, createSortOrder } from '../../services/GarphQlConversionService';
import { getColumns, getGraphQlItems } from './config';
import { useSearchParams } from "react-router-dom";
import MyDatePicker from '../antdCommon/DatePicker';
import Tags from "../tags/tags"
import { createTableFilters } from '../../services/TableFilter';
import { getDateParams, getFilterParams, getPaginationParams, getSorterParams, setQueryParams } from '../../utils/state_query_param_util';
import { getDateRange } from '../../utils/date_range_util';

export default function Cron(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const { RangePicker } = MyDatePicker;
    const [dataSource, setDataSource] = useState([])
    const graphqlName = "CronsPagination"
    let [loading, setLoading] = useState(false)
    const [dateDefaultValue, setDateDefaultValue] = useState(getDateParams(searchParams))
    const [pagination, setPagination] = useState(getPaginationParams(searchParams))

    const [filters, setFilters] = useState(getFilterParams(searchParams))

    const [sorter, setSorter] = useState(getSorterParams(searchParams))

    const graphQlItems = getGraphQlItems()

    const handleCronDelete = async (id) => {
        let data = await ajaxFetchCall(backendUrl + "/job/" + id, {
            method: "DELETE"
        })
        getData()
    }

    const [columns, setColumns] = useState(getColumns(filters, handleCronDelete));

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedJob, setSelectedJob] = useState("");
    const { Option } = Select;

    useEffect(() => {
        getData()
        setQueryParams(setSearchParams, filters, pagination, sorter, dateDefaultValue)
    }, [dateDefaultValue, filters, sorter])

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = async () => {
        if (selectedJob) {
            let data = await ajaxFetchCall(backendUrl + "/job/triggerJob", {
                method: "POST",
                body: JSON.stringify({ jobName: selectedJob })
            })
            getData()
        }
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const getData = async () => {
        let sort = createSortOrder(sorter)
        let graphqlFilters = createGraphQlFilters(filters)

        let q1 = convertToGraphQl(graphqlName, graphqlFilters, graphQlItems, sort, pagination.current, pagination.pageSize, dateDefaultValue, "createdAt")

        let body = JSON.stringify({
            query: q1
        });
        setLoading(true)
        let data = await ajaxFetchCall(backendUrl + "/graphql", {
            method: "POST",
            body: body
        })
        appendKey(data["data"][graphqlName]["items"])
        setLoading(false)
        setDataSource(data["data"][graphqlName]["items"])
        let tempPagination = { ...pagination }
        tempPagination["total"] = data["data"][graphqlName]["pageInfo"]["itemCount"]
        setPagination(tempPagination)

    }

    const onChange = (pagination, filters, sorter, extra) => {
        setPagination(pagination)
        setFilters(filters)
        let tempCols = [...columns]
        for (let filter in filters) {
            for (let col in tempCols) {
                if (tempCols[col].key == filter) {
                    tempCols[col].filteredValue = filters[filter]
                }
            }
        }
        setColumns(tempCols)
        setSorter(sorter)
    }

    const dateChange = (dates) => {
        setDateDefaultValue(dates)
    }


    useEffect(async () => {
        let namePromise = ajaxFetchCall(backendUrl + "/distinct/" + "crons/" + "name")
        let statusPromise = ajaxFetchCall(backendUrl + "/distinct/" + "crons/" + "status")
        Promise.all([namePromise, statusPromise]).then(async (values) => {
            let tempCols = [...columns]
            tempCols[0]["filters"] = createTableFilters(values[0]["response"])
            tempCols[1]["filters"] = createTableFilters(values[1]["response"])

            setColumns(tempCols)
            await getData()
        });
    }, [])

    return (
        <div>
            <div className="cron-header">
                <RangePicker
                    presets={getDateRange()}
                    defaultValue={dateDefaultValue} onChange={dateChange} />

                <Button type="primary" onClick={showModal}>
                    Trigger Job
                </Button>
                <Modal title="Trigger Job" onCancel={handleCancel} visible={isModalVisible} onOk={handleOk} okText="Trigger">
                    <Select placeholder="Select" style={{ width: 320 }} onChange={setSelectedJob}>

                        <Option value="GET_ALL_MUTUAL_FUND">GET_ALL_MUTUAL_FUND</Option>
                        <Option value="GET_NAV_OF_ALL_MUTUAL_FUND">GET_NAV_OF_ALL_MUTUAL_FUND</Option>
                        <Option value="GET_ALL_SHARES">GET_ALL_SHARES</Option>
                        <Option value="GET_HOLDING_OFF_ALL_MUTUAL_FUND">GET_HOLDING_OFF_ALL_MUTUAL_FUND</Option>
                        <Option value="UPDATE_PARAMS_OF_ALL_MUTUAL_FUND">UPDATE_PARAMS_OF_ALL_MUTUAL_FUND</Option>
                        <Option value="GET_CANDLE_OF_ALL_STOCKS_1_DAY">GET_CANDLE_OF_ALL_STOCKS_1_DAY</Option>
                        <Option value="UPDATE_SHARE_NAV_OF_MUTUAL_FUND">UPDATE_SHARE_NAV_OF_MUTUAL_FUND</Option>
                        <Option value="SET_START_NAV_DATE_OF_ALL_MUTUAL_FUND">SET_START_NAV_DATE_OF_ALL_MUTUAL_FUND</Option>
                    </Select>
                </Modal>
            </div>
            <Tags tags={filters}></Tags>
            <Table loading={loading} dataSource={dataSource} columns={columns} onChange={onChange} pagination={pagination} />
        </div>

    );
}